import { Box, Divider } from '@eatclubapp/ec-component-library';
import dayjs from 'dayjs';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import CheckSVG from '../../assets/check.svg';
import { PrimaryButton } from '../../components/button/PrimaryButton';
import { trackDetailedEvent } from '../../utils/analytics';
import CancelMembershipPage from './CancelMembershipPage';
import { primaryButtonStyles } from './CancelMembershipStyles';
import useStyles from './SuccessPageStyles';
import PauseFlowerSVG from '../../assets/images/pause_flower.svg';

const SuccessPage = ({ currentStep, totalSteps, onContinue, acceptedOffer, hasDebt }) => {
  const classes = useStyles();
  const history = useHistory();

  const pauseItems = [
    'All offers have now been disabled',
    'Your final settlement has now been processed',
    'If you need a table filled in the future, you can still access your Partner Portal and post offers in the future to re-activate your account.',
  ];

  // const temporaryPause = reason === 'pause' && reasonData?.pauseWeeks !== null;
  // const getReactivationDate = () => {
  //   if (reason === 'pause' && reasonData?.pauseWeeks !== null) {
  //     if (reasonData?.pauseWeeks === 'custom') {
  //       return dayjs().add(reasonData?.customDate, 'weeks').format('DD/MM/YYYY');
  //     }
  //     return dayjs().add(reasonData?.pauseWeeks, 'weeks').format('DD/MM/YYYY');
  //   }
  //
  //   return null;
  // };
  //
  // if (temporaryPause) {
  //   return (
  //     <CancelMembershipPage
  //       currentStep={currentStep}
  //       totalSteps={totalSteps}
  //       isSaving={false}
  //       featureImage={<PausePhoneSVG />}
  //     >
  //       <Box className={classes.mainContent}>
  //         <Box className={classes.title}>Success, your membership has now been paused.</Box>
  //         <Box className={classes.pageContent}>
  //           This will be re-activated on {getReactivationDate()}.
  //           <PrimaryButton style={primaryButtonStyles} onClick={onContinue}>
  //             View offers
  //           </PrimaryButton>
  //         </Box>
  //       </Box>
  //     </CancelMembershipPage>
  //   );
  // }

  if (hasDebt) {
    return (
      <CancelMembershipPage
        currentStep={currentStep}
        totalSteps={totalSteps}
        isSaving={false}
        featureImage={
          <img
            src='https://eccdn.com.au/partnerportal/img/pause_phone_2x.png'
            style={{ maxWidth: '500px', width: '100%' }}
            alt='A hand holding a phone displaying the EatClub logo on its screen.'
          />
        }
      >
        <Box className={classes.mainContent}>
          <Box className={classes.title}>Your request has been submitted</Box>
          <Box className={classes.pageContent}>
            Due to outstanding debt, your account manager will contact you shortly to help you
            manage your account.
            <PrimaryButton
              style={primaryButtonStyles}
              onClick={() => {
                trackDetailedEvent(`Cancellation Completed - In debt`);
                history.push('/settlements/pay-balance');
              }}
            >
              Manage outstanding debt
            </PrimaryButton>
          </Box>
        </Box>
      </CancelMembershipPage>
    );
  }

  if (acceptedOffer) {
    return (
      <CancelMembershipPage
        currentStep={currentStep}
        totalSteps={totalSteps}
        isSaving={false}
        featureImage={
          <img
            src='https://eccdn.com.au/partnerportal/img/pause_phone_2x.png'
            style={{ maxWidth: '500px', width: '100%' }}
            alt='A hand holding a phone displaying the EatClub logo on its screen.'
          />
        }
      >
        <Box className={classes.mainContent}>
          <Box className={classes.title}>Enjoy the week on us</Box>
          <Box className={classes.pageContent}>
            This venue will be re-activated on {dayjs().add(1, 'week').format('DD/MM/YYYY')}.
            <PrimaryButton style={primaryButtonStyles} onClick={onContinue}>
              View offers
            </PrimaryButton>
          </Box>
        </Box>
      </CancelMembershipPage>
    );
  }

  return (
    <CancelMembershipPage
      currentStep={currentStep}
      totalSteps={totalSteps}
      isSaving={false}
      featureImage={<PauseFlowerSVG />}
    >
      <Box className={classes.mainContent}>
        <Box className={classes.title}>
          Your account is <br />
          now paused.
        </Box>
        <Box className={classes.pageContent}>
          We’ve hit pause on your offers. This means no more hungry diners heading your way.
          <Box className={classes.pauseItems}>
            {pauseItems.map((pauseItem) => (
              <Fragment key={pauseItem}>
                <Box className={classes.pauseItem}>
                  <Box className={classes.checkMark}>
                    <CheckSVG />
                  </Box>
                  <Box className={classes.pauseItemText}>{pauseItem}</Box>
                </Box>
                <Divider color='#E3D9CB' />
              </Fragment>
            ))}
          </Box>
          <PrimaryButton style={primaryButtonStyles} onClick={onContinue}>
            View offers
          </PrimaryButton>
        </Box>
      </Box>
    </CancelMembershipPage>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);
